export const GUSTAVS_MARIEHAMN = {
  name: "Kustavi-Maarianhamina",
  routes: [
    {
      weight_name: "routability",
      legs: [
        {
          summary: "Norra Linjen, 2",
          steps: [],
          distance: 135105.5,
          duration: 15172.993,
          weight: 15172.993,
        },
      ],
      geometry: {
        coordinates: [
          [21.355244, 60.544895],
          [21.336164, 60.542599],
          [21.320278, 60.541069],
          [21.247164, 60.507252],
          [21.215744, 60.487499],
          [21.094908, 60.490108],
          [21.058243, 60.503288],
          [21.091188, 60.472973],
          [21.065182, 60.445923],
          [21.061655, 60.445656],
          [21.046095, 60.433849],
          [21.050991, 60.429413],
          [21.051111, 60.429249],
          [21.051376, 60.428871],
          [21.037998, 60.404575],
          [21.017891, 60.402519],
          [21.03474, 60.376926],
          [21.037331, 60.375885],
          [21.064476, 60.359814],
          [21.038078, 60.356583],
          [21.028391, 60.330433],
          [20.995947, 60.317463],
          [21.012392, 60.308826],
          [20.989565, 60.291664],
          [20.825382, 60.284672],
          [20.800707, 60.295265],
          [20.790161, 60.290462],
          [20.790129, 60.301392],
          [20.751287, 60.318241],
          [20.65122, 60.269176],
          [20.449139, 60.238106],
          [20.41366, 60.224216],
          [20.377817, 60.231209],
          [20.373426, 60.242363],
          [20.342089, 60.243843],
          [20.278408, 60.205589],
          [20.277596, 60.2057],
          [20.272305, 60.207893],
          [20.271786, 60.208229],
          [20.160688, 60.223621],
          [20.142168, 60.221279],
          [20.105843, 60.22337],
          [20.080683, 60.239693],
          [20.038019, 60.245998],
          [19.957232, 60.20784],
          [19.935118, 60.131985],
          [19.93508, 60.131767],
          [19.934225, 60.128128],
          [19.934099, 60.127945],
          [19.933933, 60.12273],
          [19.933987, 60.122501],
          [19.93928, 60.114826],
          [19.940674, 60.114162],
          [19.943935, 60.114628],
        ],
        type: "LineString",
      },
      distance: 135105.5,
      duration: 15172.993,
      weight: 15172.993,
    },
  ],
  waypoints: [
    {
      distance: 0.466,
      name: "Kivimaantie",
      location: [21.355244, 60.544895],
    },
    {
      distance: 1.296,
      name: "Lemlandsvägen",
      location: [19.943935, 60.114628],
    },
  ],
  code: "Ok",
  uuid: "W1KwPnPAsrz0F7eCSN-pGwTGMWdvhwxMkJZ0q6LdBAVJlgyQXBfpig==",
}
